import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.SentimentEvolutionView extends Monitoring.Reports.Executive.AbstractSectionView
  genericTemplate: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  tagName: 'section'
  id: 'brand-sentiment-evolution'
  chartClass: 'sentiment-column-container column-chart'
  icon: 'column'

  initialize: (@options = {}) ->
    @colors = @options.colors

  render: ->
    @bindChartsReady(1)
    @$el.html(@genericTemplate(self: this))
    @addBars('.chart_container')
    return this

  addBars: (divId) ->
    @specific_settings ||= {}
    @specific_settings.benchmark = true
    query = _.extend({}, @accountSentimentQuery(), @getExtraQuery())
    @setBenchmarkSettingsIfNecessary(query)

    f = @_addChart(@options.chartApi.singleDimension, @_columnOptions)
    f(query, divId)

  _columnOptions: (response, divId) =>
    @_removeMissing({ series: response.benchmark_data })

    hashSeries = {}
    _.each [response.series, response.benchmark_data], (serie) ->
      _.each serie[0].data, (data) ->
        hashSeries[data.name] ||= []
        hashSeries[data.name].push(data.y)

    series = _.map(hashSeries, (values, index) => { name: index, data: values, color: @colors[index.toLowerCase()] })
    serie.type = 'column' for serie in series
    categories = ['Periodo actual', 'Periodo benchmark']

    _.extend(@highchartsColumnOptions(divId, series, categories), { legend: {enabled: true},plotOptions: {column: {stacking: 'percent',dataLabels: {enabled: true, color: '#888',style: {fontWeight: 'bold'}}}}})
